import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import CustomDropdown from './Components.tsx/CustomDropdown';
import AdvertiseWithMeImage from './AdvertiseWithMe.jpg'; // Import the header image
import { Footer } from '../Landing';

const stripePromise = loadStripe('your-publishable-key-here'); // Replace with your Stripe publishable key

const AdvertiseWithUs: React.FC = () => {
  const [adType, setAdType] = useState<'image' | 'video'>('image');
  const [advertiserName, setAdvertiserName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [callToActionTitle, setCallToActionTitle] = useState('');
  const [callToActionLink, setCallToActionLink] = useState('');
  const [budget, setBudget] = useState<number>(0);
  const [file, setFile] = useState<File | null>(null);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };

  const calculateCostPerImpression = () => (adType === 'image' ? 0.04 : 0.05);

  const adjustBudgetToNearest = (value: number) => {
    const adjustedValue = Math.round(value * 20) / 20; // Round to the nearest 0.05
    setBudget(adjustedValue);
  };

  const handleSubmit = async () => {
    if (!advertiserName || !title || !description || !callToActionLink || !file || budget <= 0) {
      alert('Please fill out all fields and upload a file.');
      return;
    }

    const impressions = Math.floor(budget / calculateCostPerImpression());
    const stripe = await stripePromise;

    if (!stripe) {
      console.error('Stripe failed to initialize.');
      return;
    }

    // Create a checkout session on your server
    const response = await fetch('/create-checkout-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        adType,
        advertiserName,
        title,
        description,
        callToActionTitle,
        callToActionLink,
        budget,
        impressions,
      }),
    });

    const session = await response.json();

    // Redirect to Stripe Checkout
    const result = await stripe.redirectToCheckout({ sessionId: session.id });

    if (result.error) {
      console.error(result.error.message);
    }
  };

  return (
       <div
        style={{
            backgroundColor: 'black',
            fontFamily: 'Arial, sans-serif',
            height: '100vh',
            width: '100vw',
        }}
    >
        <div
            style={{
                backgroundColor: 'white',
                fontFamily: 'Arial, sans-serif',
                height: '100vh',
                overflowY: 'scroll',
                paddingBottom: 100,
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '300px',
                    backgroundImage: `url(${AdvertiseWithMeImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: '0 0 20px 20px',
                }}
            ></div>
            <div style={{ maxWidth: '800px', margin: '20px auto', textAlign: 'center' }}>
                <h1 style={{ fontSize: '36px', color: '#333', marginBottom: '10px' }}>Advertise With Us</h1>
                <p style={{ fontSize: '18px', color: '#555', marginBottom: '30px' }}>
                    Reach your audience with targeted ads. Choose between image or video ads and set your budget.
                </p>
            </div>
            <form
                onSubmit={(e) => e.preventDefault()}
                style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    padding: '30px',
                }}
            >

            <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                    Ad Type:
                </label>
                <CustomDropdown
                    options={[
                    { value: 'image', label: 'Image ($0.04 per impression)' },
                    { value: 'video', label: 'Video ($0.05 per impression)' },
                    ]}
                    selectedValue={adType}
                    onChange={(value) => setAdType(value as 'image' | 'video')}
                />
                </div>

                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Advertiser Name:
                    </label>
                    <input
                        type="text"
                        value={advertiserName}
                        onChange={(e) => setAdvertiserName(e.target.value)}
                        placeholder="Enter your name"
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            outline: 'none',
                        }}
                        required
                    />
                </div>
    
                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                    <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Title:
                    </label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter ad title"
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            outline: 'none',
                        }}
                        required
                    />
                </div>
    
                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                    <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Description:
                    </label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter ad description"
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            resize: 'none',
                            height: '100px',
                            outline: 'none',
                        }}
                        required
                    />
                </div>
    
                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                    <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Call to Action Title:
                    </label>
                    <input
                        type="text"
                        value={callToActionTitle}
                        onChange={(e) => setCallToActionTitle(e.target.value)}
                        placeholder="Enter call-to-action title"
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            outline: 'none',
                        }}
                        required
                    />
                </div>
    
                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                    <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Call to Action Link:
                    </label>
                    <input
                        type="url"
                        value={callToActionLink}
                        onChange={(e) => setCallToActionLink(e.target.value)}
                        placeholder="Enter call-to-action link"
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            outline: 'none',
                        }}
                        required
                    />
                </div>
    
                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                    <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Upload {adType === 'image' ? 'Image' : 'Video'}:
                    </label>
                    <input
                        type="file"
                        accept={adType === 'image' ? 'image/*' : 'video/*'}
                        onChange={handleFileUpload}
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            outline: 'none',
                        }}
                        required
                    />
                </div>
    
                <div style={{ marginBottom: '20px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>
                    <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '8px' }}>
                        Budget ($):
                    </label>
                    <input
                        type="number"
                        value={budget}
                        onChange={(e) => adjustBudgetToNearest(Number(e.target.value))}
                        placeholder="Enter your budget"
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '15px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9',
                            outline: 'none',
                        }}
                        required
                    />
                    <p style={{ fontSize: '14px', color: '#777', marginTop: '5px' }}>
                        Budget will be adjusted to the nearest $0.05.
                    </p>
                </div>
    

                <button
                type="button"
                onClick={handleSubmit}
                style={{
                    width: '50%',
                    padding: '20px',
                    fontSize: '18px',
                    backgroundColor: '#2093ff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '40px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s ease',
                    marginBottom: '100px',
                    alignSelf: 'center',
                    marginLeft: '25%',
                    marginRight: '25%',
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0d7ad6')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#2093ff')}
                >
                Submit
                </button>
            </form>
            <Footer />
            <span style={{ height: 100}}/>
        </div>
    </div>
  );
};

export default AdvertiseWithUs;